define([
    'lodash',
    'common/utils',
    'jquery'
], function(
    _,
    Utils,
    $
){
    return {
        data: function(){
            return {
                hasInit: false
            };
        },
        computed: {
            pos: function(){
                return this.$route.query.pos || '';
            },
            tab: function(){
                return this.$route.query.tab || '';
            },
            pageContentStyle: function(){
                return {
                    visibility: this.hasInit ? 'visible' : 'hidden'
                };
            }
        },
        watch: {
            '$route': 'onRouteChange'
        },
        methods: {
            onRouteChange: function(){},
            genTabRoute: function(tab){
                return {
                    query: {tab: tab}
                };
            },
            genQueryRoute: function(query){
               return {
                   query: _.assign({}, this.$route.query, query)
               };
            },
            genPosRoute: function(pos){
                return this.genQueryRoute({pos: pos});
            },
            replaceRoute: function(route){
                this.$router.replace(route);
            },
            replaceTabRoute: function(tab){
                this.replaceRoute(this.genTabRoute(tab));
            },
            replacePosRoute: function(pos){
                this.replaceRoute(this.genPosRoute(pos));
            },
            genPos: function(arr){
                return arr.join('.');
            },
            scrollToPos: function(){
                var posArr = this.pos.split('.');
                while($(getSelector(posArr)).length <= 0 && posArr.length > 1){
                    posArr.pop();
                }
                Utils.scrollToSelector(getSelector(posArr), 0);

                function getSelector(arr){
                    return '[data-pos="'+arr.join('.')+'"]';
                }
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/mixin/route.js
// module id = 113
// module chunks = 1 3 8